import { VersionedSnippet, AssetUrlProps } from '@cld/code-snippet-next';
import { FetchSnippetProps } from '../serverTypes';
import { createUrlSnippet, parseParsedUrl, groupSnippets } from '../utils';
import { fetchSnippetsRaw } from './fetchSnippetsRaw';

export interface SnippetsResponse {
  parsedSnippets: VersionedSnippet[];
  parsedUrl?: AssetUrlProps;
}

/**
 * fetches snippets from sdk service and parse it according to cld/code-snippet
 * @param options
 */
export const fetchParsedSnippets = async (options: FetchSnippetProps): Promise<SnippetsResponse> => {
  const data = await fetchSnippetsRaw(options);
  const urlSnippet = createUrlSnippet(data.parsed_url);
  const parsedSnippets = groupSnippets(data.code_snippets);
  parsedSnippets.unshift(urlSnippet);
  const parsedUrl = parseParsedUrl(data.parsed_url);

  return {
    parsedSnippets,
    parsedUrl,
  };
};

export type FetchSnippets = typeof fetchParsedSnippets;
